import request from '../utils/request';

// 分页查询资讯文章列表
export const listArticles = (page = 1, size = 10, queryDTO = {}) => {
  return request({
    url: '/article/list',
    method: 'post',
    params: { page, size },
    data: queryDTO
  });
};

// 根据ID获取资讯文章详情
export const getArticleById = (id) => {
  return request({
    url: `/article/${id}`,
    method: 'get'
  });
};

// 创建资讯文章
export const createArticle = (data) => {
  return request({
    url: '/article',
    method: 'post',
    data
  });
};

// 更新资讯文章
export const updateArticle = (id, data) => {
  return request({
    url: `/article/${id}`,
    method: 'put',
    data
  });
};

// 删除资讯文章（逻辑删除）
export const deleteArticle = (id) => {
  return request({
    url: `/article/${id}`,
    method: 'delete'
  });
};

// 批量更新文章排序（用于拖拽排序）
export const updateArticleOrders = (items) => {
  return request({
    url: '/article/order/batch',
    method: 'put',
    data: { items }
  });
};

